import React, { useRef } from "react";
import UsersOverviewOne from "../components/UsersOverviewOne";
import TeamDashboardData from "./TeamDashboardData";
import UsersOverviewTwo from "../components/UsersOverviewTwo";
import TeamStatistics from "./TeamStatistics";
import UnitCountTwo from "./UnitCountTwo";
import FacilityDetailDashboardData from "./FacilityDetailDashboardData";
import DailyTeamAttendance from "./DailyTeamAttendance";

const DashBoardLayerTwo = () => {
  const teamAttendanceRef = useRef();

  return (
    <>
      {/* UnitCountOne */}

      <UnitCountTwo />

      <TeamStatistics />

      {/* LatestRegisteredOne */}
      <TeamDashboardData />

      <section className="row gy-4 mt-4">
        <div className="col-12">
          <h2 className="fs-2">Tasks</h2>
          <FacilityDetailDashboardData rows={5} />
        </div>
      </section>

      <section className="row gy-4 mt-4">
        <div className="col-12">
          <h2 className="fs-2">Facility Attendance</h2>
          <DailyTeamAttendance ref={teamAttendanceRef} />
        </div>
      </section>
    </>
  );
};

export default DashBoardLayerTwo;
